import { Container, Typography } from "@mui/material";
import { TitleWithBody } from "../../types/utils";
import useIsMobileView from "../../utils/hooks/useIsMobileView";
import CollapsibleText from "../Common/CollapsibleText";

const InfoForSpecialist = () => {
  const IsMobileView = useIsMobileView();
  return (
    <Container
      disableGutters
      sx={{
        height: "100%",
        pl: IsMobileView ? "0vw" : "1%",
        pt: IsMobileView ? "5%" : "0vh",
      }}
    >
      <Container disableGutters sx={styles.contentContainer}>
        <Container disableGutters sx={styles.titleContainer}>
          <Typography variant="h5" align="center">
            Info spetsialistile
          </Typography>
        </Container>
        {PatientInfo.map((data, index) => {
          return <CollapsibleText key={index} title={data.title} body={data.body} references={data.references} />;
        })}
      </Container>
    </Container>
  );
};

export default InfoForSpecialist;

const styles = {
  contentContainer: {
    height: "inherit",
    backgroundColor: "white",
    borderRadius: "20px",
    py: "5%",
    px: "5%",
  },
  titleContainer: {
    display: "flex",
    justifyContent: "center",
    mb: "6%",
  },
  textContainer: {
    display: "flex",
    flexDirection: "column",
  },
};

const PatientInfo: TitleWithBody[] = [
  {
    title: "Mida annab DÜKA test mulle spetsialistina? ",
    body:
      "Kuna düsartria näol on tegemist kõnehäirega, peab logopeedil olema vahend, millega hinnata" +
      " oraalmotoorikale lisaks kõne arusaadavust kuulajale. DÜKA test lubab hinnata kõne arusaadavust " +
      "ehk seda, kuivõrd efektiivselt suudab kuulaja eraldada akustilisest signaalist kõnelisi komponente" +
      " (foneetilisi ja leksikaalseid ühikuid). Just kõne arusaadavuse parandamine ongi tavaliselt " +
      "düsartria teraapia eesmärgiks. Eduka kõneteraapia läbiviimiseks on oluline hinnata kõneprobleemi " +
      "olemust ja raskusastet nii teraapia alguses kui käigus ning teha seda võimalikult " +
      "objektiivselt.",
    references: {},
  },
  {
    title: "Mis on DÜKA testi alused ja eripära? ",
    body:
      "DÜKA test on loodud Assessment of Intelligibility of Dysarthric Speech (ASSIDS, Yorkston & " +
      "Beukelman, 1984) mudeli alusel. DÜKA test, nagu ka ASSIDS, sisaldab 50 sõnakogumit, mis koosnevad " +
      "12 sarnase kõlapildiga sõnast (kokku 600 sõna). Patsient loeb juhuslikult genereeritud 50-sõnalise " +
      "listi, logopeed valib kuuldud sõna ette antud nimekirjast ning tulemuse saab teada automaatselt: " +
      "selle arvutamisel loetakse õigeks vaid kuulaja poolt täpselt ära tuntud sõnad. Maksimaalne skoor on " +
      "50 punkti ehk 50-punktiline sooritus on 100%-line. Testi loomise teoreetilised alused ning katsetamise " +
      "protseduur on kirjeldatud Oksana Palikova magistritöös [“Kõne arusaadavuse hindamine omandatud düsartriaga " +
      "eestikeelsetel patsientidel”][1], juhendaja Merje Viigand (Tartu Ülikool, 2022).",
    references: {
      1: () => (
        <a href="https://dspace.ut.ee/handle/10062/83429" target="_blank" rel="noreferrer">
          “Kõne arusaadavuse hindamine omandatud düsartriaga eestikeelsetel patsientidel”
        </a>
      ),
    },
  },
  {
    title: "Kas DÜKA test lubab määrata düsartria raskusastet? ",
    body:
      "DÜKA test lubab düsartrilise kõne arusaadavust mõõta kvantitatiivselt (numbrites näitlikustada). " +
      "Testiga saab täpselt määrata kõne teraapia-eelset taset ning mõõta teraapiaga seotud dünaamikat. " +
      "Samuti on testi tulemustele tuginedes spetsialistidel omavahel kergem patsiendi seisundit " +
      "kirjeldada, kui patsient näiteks ühest asutusest teise edasi liigub. Otsest seost testi alusel " +
      "saadud skoori ja raskusastme vahel hetkel ei ole, kuna test ei ole piisavalt tundlik kergemate " +
      "raskusastmete osas.",
    references: {},
  },
  {
    title: "Lisateave",
    body:
      "Lisainforatsiooni saamiseks palun tutvuge järgmise allikaga: Oksana Palikova. Kõne arusaadavuse hindamine " +
      "omandatud düsartriaga eestikeelsetel patsientidel. Magistritöö. Juhendaja Merje Viigand. Tartu Ülikool, 2022. " +
      "[https://dspace.ut.ee/handle/10062/83429][1] või kirjutage aadressil [oksana.palikova@keskhaigla.ee][2]",
    references: {
      1: () => (
        <a href="https://dspace.ut.ee/handle/10062/83429" target="_blank" rel="noreferrer">
          https://dspace.ut.ee/handle/10062/83429
        </a>
      ),
      2: "mailto:oksana.palikova@keskhaigla.ee",
    },
  },
];
